<template>
    <div class="table__container" :style="tableStyle">
        <table>
             <thead>
                <tr>
                    <th v-if="config.hasCheckbox" width="4%"><Checkbox class="th__items__container" name="all" id="all" @handleCheck="checked('all')"/></th>
                    <th v-for="(col , index) in config.columns" :key="index" :width="col.width" @click="sortItem(col.key)"><div class="th__items__container"><div><Icon v-if="col.icon && col.icon.before" :icon="col.icon.before" :width="21" :height="22"  color="#4e68b0"/> <span class="col__name">{{col.name}} </span></div><span v-if="col.icon && col.icon.after" class="icon__after" @click="$emit('iconClicked',col.key)"><Icon :icon="col.icon.after"  color="#4e68b0" :width="29" :height="21"/></span><span class="sort__arrows"><i class="fas fa-angle-up" :style="{color : sortby==col.key && sort =='asc' ? '#4e68b0' :'#d5d4d4'}"></i><i class="fas fa-angle-down" :style="{color : sortby==col.key && sort =='desc' ? '#4e68b0' : '#d5d4d4'}"></i></span> </div></th>
                    <th v-if="config.actions && config.actions.elements && config.actions.elements.length !=0" :width="config.actions.width"><div class="th__items__container">{{config.actions.name}}</div></th>
                </tr>
                </thead>
            <tr class="tbody" v-for="(item, itemIndex) in data" :key="itemIndex">
                <td v-if="config.hasCheckbox">
                    <Checkbox :name="item.name" :id="item.id" :check="checkAll || selectedProjects.includes(item.id)" class="checkbox__container" @handleCheck="checked(item.id)" />
                </td>
                <td class="tab__elements" v-for="(col, colIndex) in config.columns" :key="colIndex" @click="selected(item,config.action)">
                    <div v-if="col.type" @click="$emit('selectMedia',item.id,col.type,col.key, item)">
                        <components :is="col.component" :type="col.type" :poster="col.poster ? col.poster : null" :color="col.color ? col.color : '#fff'" :item="{...item[col.key],_id:item.id}" :activeMedia="activeMedia" @play="playedMedia"/>
                    </div>
                    <div v-else>{{item[col.key] ? item[col.key] : 'N/A'}}</div>
                </td>
                <td class="tab__actions" v-if="config.actions && config.actions.elements && config.actions.elements.length!=0">
                    <div class="actions__container" >
                        <div class="actions__elements" v-if="config.actions.hasSimpleList">
                            <template v-for="(action , actionIndex) in config.actions.elements" >
                                <span v-if="action.icon" :key="actionIndex" v-html="action.icon" :style="`color : ${action.color}`" @click="selected(item,action.action)"></span>
                                <Button v-else :key="actionIndex" v-bind="buttonConfig" @click="selected(item,action.action)">{{action.name}}</Button>
                            </template>
                            <!-- <span class="delete__mark" @click="remove(item)"></span>  -->
                        </div> 
                        <Icon v-if="config.actions.hasToggleList"  class="list__icon" :class="{'active__list' : itemIndex == activeAction}" icon="list" color="gray" :width="20" :height="20" @click="showActionList(itemIndex)"/>
                        <div class="actions__bloc" v-if="activeAction == itemIndex && config.actions.hasToggleList">
                            <GalleryActions :actions="config.actions.list" :story="item" @clicked="toggleActions(itemIndex,item)"/>
                        </div>                                                                                  
                    </div>
                </td>
            </tr>
            <!-- <tr v-if="!data || !data.length> 0">
                <div>
                no data

                </div>
            </tr> -->
        </table>
    </div>
</template>

<script>
import Icon from '../global/Icon.vue'
import Button from '../global/Button.vue';
import Checkbox from '../global/CheckBox.vue';
import Media from '../global/Media.vue'
import GalleryActions from '../global/sections/GalleryActions.vue';
import GalleryListMixin from '../../mixins/GalleryListMixin';
export default {
    mixins : [GalleryListMixin],
    components : { Icon, Button, GalleryActions, Checkbox, Media },
    props : {
        data : Array,
        config : { type : Object, default : null },
    },
    data(){
        return {
            activeMedia : null,
            selectedProjects:[],
            checkAll:false,
            storyContainer : [],
            sortby:null,
            sort:null,
            activeAction : null,
            buttonConfig : {
                padding : { x : 1.5 , y : .2},
                backgroundColor : "#a1d2f1",
                radius : 5,
                size : "13px",
                margin : .2
            },
        }
    },
    computed : {
        tableStyle(){
            return {
                border : this.config.border ? '2px solid #e3ecf0' : 'none'
            }
        }
    },
    watch : { 
        "$store.state.modelOpened" (value) {
            if(!value) this.activeAction = null;
        },
    },
    methods : {
        playedMedia(mediaId) {
            this.activeMedia = mediaId
        },
        sortItem(colName){
            this.sortby = colName;
            this.sort = this.sort == 'desc' ? 'asc' : 'desc';
            this.$emit('iconClicked',colName)
        },
        selected(item, actionName) {
            this.$emit(actionName, item)
        },
        checked(projectId) {
            if(projectId == 'all') {
                this.checkAll = !this.checkAll;
                if(this.checkAll) {
                    for (const project of  this.data) {
                        this.selectedProjects.push(project.id);
                    }
                }else this.selectedProjects = [];
            }else {
                this.selectedProjects.includes(projectId) ? this.selectedProjects.splice(this.selectedProjects.indexOf(projectId),1) : this.selectedProjects.push(projectId);
            }
            console.log(this.selectedProjects);
            this.$emit('input',this.selectedProjects)
        }
    }
 
}
</script>

<style lang="scss" scoped>
    .table__container[data-v-7a3521a5] {
        background-color: #f8f8f8;
        font-size: .9rem;
        border-radius: 0.5rem;
        overflow-x: auto;
        width: 100%;
    }

    table {
        min-width: 1225px;
    }
    
    thead {
        color : #6e6b7b;
        border-radius: .5rem .5rem 0 0;
        border-bottom : 3px solid #F2F3F9;
        th {
            // text-align : center;
            text-transform: uppercase;
            position: relative;
            cursor: pointer;
            background-color : #f8f8f8;
            .th__items__container{
                padding: .5rem 1rem;
                display : flex;
                align-items : center;
                justify-content: space-between;
                span:first-child { padding-right: .5rem}
            }
        
        }
        th:first-child div  {
            border-top-left-radius: .5rem;
            position:absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            display:flex;
            align-items: center;
            // justify-content: center;
            label {
                margin: 0 !important;
            }

        }
        th:last-child div  {
            border-top-right-radius: .5rem;
            // padding: 1.79rem;
        }
    
    }
    .sort__arrows {
        display:flex;
        flex-direction: column;
    }
    .checkbox__container {
            display:flex;
            align-items: center;
            // justify-content: center;
            // padding : 0.8rem 2rem;
    }
    .th__items__container {
        width : 100%;
        display : flex;
        align-items : center;
        // justify-content : center;
        // .col__name {
        //     margin : 0 .5rem;
        // }
       
    }
    .icon__after {
        background-color: #4e68b0;
        border-radius: .5rem;
        padding : 0.2rem .1rem ;
        margin: 0 .5rem;
        box-shadow:  1px 2px 4px 0px #444444;
        display : flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:hover {
        background-color: #5f80dc;
        }
    }
    .tbody {
        // text-align : center;
        background-color: #fff;
        td {
            border-bottom: 2px solid #F2F3F9;
            padding: .6rem 1rem;
        }
        &:hover {
            opacity: .8;
            cursor: pointer;
        }
        // .tab__elements div {
        //     padding : 1rem 0;
        //     margin-bottom: .5rem ;
        // }
        .actions__container {
            // padding : .8rem 2rem;
            margin-bottom: .5rem;
            // border-left : 2px solid #F2F3F9;
        }
       .actions__elements {
           display : flex;
           align-items : center;
           padding: 0 .5rem;
       }

        // td:first-child div , td:nth-child(3) div, td .actions__container {
        //         background-color : #ffffff;
        // }
        // td:nth-child(2) div {
        //         background-color : #F2F3F9;
        // }
        
    }
    tr:last-child td div {
        margin-bottom : 0 !important;
    }
    tr:last-child td:first-child div {
        border-bottom-left-radius : .5rem;
    }
    tr:last-child td:last-child div {
        border-bottom-right-radius : .5rem;

    }
    .actions__container {
        display : flex;
        align-items : center;
        justify-content : flex-end;
        padding-right : 2rem !important;
        width : 100%;
        position : relative;
        // span:first-child {
        //     padding : 0 2rem;
        //     display : flex;
        // }
        span {
            padding : 0 .4rem;
        }
    }
    .delete__mark {
        padding : 1rem;
        margin : 0 .5rem;
        background-color  :#fbdbdbd6;
        border-radius : 50rem ;
        position : relative;
        cursor: pointer;
        &:hover {
            opacity: .9;
        }
        &:before, &:after {
            content : '';
            padding : .1rem;
            position : absolute;
            height : 1rem;
            top : .5rem;
            background-color : #ff7373d5;
        }
        &:before {
            transform : rotate(-40deg);
            right : .9rem
        }
        &:after {
            transform : rotate(40deg);
            left : .9rem;
        }
    }
    .list__icon{
        cursor: pointer;
        transition : .3s;
        background-color : #ffffff ;
        padding : .3rem;
        border-radius: .5rem;
        z-index: 2;
        &:hover {
            background-color : #3C66FF;
            color : #ffffff !important;
        }
    }
    .active__list {
        color : #ffffff!important;
        background-color : #3C66FF;
       
    }
    .actions__bloc {
        position : absolute;
        top: -11rem;
        right: 5.5rem;
        width: 13.5rem;
        z-index: 3;
        background-color : transparent;
        div:first-child {
            display : flex;
            justify-content:flex-end;
            box-shadow: none !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/global/Table.vue